import { render, staticRenderFns } from "./bankinfo.vue?vue&type=template&id=13964a28&scoped=true&"
import script from "./bankinfo.vue?vue&type=script&lang=js&"
export * from "./bankinfo.vue?vue&type=script&lang=js&"
import style0 from "./bankinfo.vue?vue&type=style&index=0&id=13964a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13964a28",
  null
  
)

export default component.exports